<template>
  <div class="xh-esg-index">
    <div class="xh-esg-sj-banner">
      <div class="banner"></div>
    </div>
    <div class="content">
      <div class="top">
        <span class="icon"
          ><img src="../../assets/white_theme/esg-sj-icon.png" /></span
        ><b style="color: var(--font_01)">ESG入驻</b>
      </div>

      <div class="middle">
        <div class="introduction">
          ESG入驻为企业用户提供互动渠道，提供企业入驻服务包括ESG名片、ESG档案、ESG评价报告、ESG风险监测、ESG发布、ESG培训等六项权益。
        </div>
        <div class="card">
          <div class="goldCard">
            <img src="../../assets/white_theme/esg-rz-card.png" alt="" />
          </div>
          <div class="goldCardint">
            <div class="circle"></div>
            <b class="bbb">ESG名片</b>
            <br />
            <div class="mingpian">
              通过ESG名片，获取企业ESG动态、ESG发展水平，展示企业践行ESG发展理念。
            </div>
          </div>
        </div>
        <div class="serve">
          <div class="serveLeft">
            <div class="circle"></div>
            <b class="bbb">ESG档案与评价报告</b>
            <div class="serveInt">
              生成企业ESG名片和标识，建立企业自身的ESG档案，塑造企业履行社会责任、践行ESG可持续发展理念的形象；支持免费下载企业自身的ESG评价报告，查询同行业企业ESG发展水平，自我检视企业ESG发展长短板。
            </div>
          </div>
          <div class="serveRight">
            <div class="serveRightPng"></div>
          </div>
        </div>
        <div class="liucheng clearfix">
          <div class="liuchengleft">
            <img src="../../assets/white_theme/esg-rz-esgesg.png" style="width: 100%" alt="" />
           <!--  <div class="liuchengleft-content">
              新华CN-ESG应用场景广泛，可以帮助入驻企业在ESG信息披露、ESG评价、风险管理、全景发布等方面，助力企业践行ESG发展理念，促进企业高质量发展。
            </div> -->
          </div>
          <div class="liuchengright">
            <div class="circle"></div>
            <b class="bbb">ESG全景发布</b>
            <br />
            <div class="liuchengright-content">
            能够获取ESG领域最新监管动态，把握ESG发展脉搏；《“碳”路领航者》栏目充分展现企业在社会责任与担当、ESG可持续发展、低碳零碳化领域的实践创新与先进经验，凸显企业绿色低碳先锋的榜样作用。
            </div>
          </div>
          
        </div>
        <div class="middle-introduction">
             新华CN-ESG应用场景广泛，可以帮助入驻企业在ESG信息披露、ESG评价、风险管理、全景发布等方面，助力企业践行ESG发展理念，促进企业高质量发展。
        </div>
      </div>
      <div class="bottom">
        <span class="icon"
          ><img src="../../assets/white_theme/esg-sj-icon.png" /></span
        ><b style="color: var(--font_01)">入驻企业</b>
        <div class="rzcompany">
          <div class="one"></div>
          <div class="box"></div>
          <div class="middlebox" @click="gopingan()">
            <img src="../../assets/white_theme/esg-rz-spingan.png" alt="" />
          </div>
          <div class="box"></div>
          <div class="box"></div>
        </div>
      </div>
      <span class="infoBox1">
        上市公司可免费获取公司自身ESG评价报告，欲获取评价报告，或反馈ESG相关数据，或了解更多企业ESG入驻服务，欢迎联系中经社ESG团队。
        <br />
        <!-- 电子邮件:&nbsp;chensizhan&#64;xinhua.org&nbsp;&nbsp;&nbsp;wangbo08&#64;xinhua.org
         -->
         电子邮件:&nbsp;machen@xinhua.org&nbsp;&nbsp;&nbsp;wangbo08@xinhua.org
        <br />
      </span>
      <el-button class="ruzhubtn" @click="goruzhu()"
        ><span>我要入驻</span></el-button
      >
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";

export default {
  data() {
    return {
      tableData: [
        {
          date: "2016-05-02",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄",
        },
        {
          date: "2016-05-04",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1517 弄",
        },
        {
          date: "2016-05-01",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1519 弄",
        },
      ],
      tableHeight:
        document.documentElement.clientHeight || document.body.clientHeight,
      loading: false,
      page: {
        currentPage: 1,
        totalPage: 1,
      },
      defaultPageSizeList: [10, 20, 30, 50, 100],
      pageInput: 1,
      sizeForm: {
        keyWord: "",
        infoSource: "",
        title: "",
        type: "0",
        pageNo: 1,
        pageSize: 100,
        beginDate: "",
        endDate: "",
      },
      inputControl: false,
    };
  },
  mounted() {
    var _this = this;
    _this.LocalGetTableData();
  },
  methods: {
    ...mapActions("dataInfo/index", {
      getTableData: "GET_TABLE_DATA",
    }),
    gopingan() {
      this.$router.push({
        name: "card",
      });
    },
    goruzhu() {
      this.$utils.open(
        "https://www.credit100.com/registerEnterp?type=2&tag=esg&title='新华CN-ESG企业入驻'"
      );
    },
    handleCurrentChange(val) {
      // console.debug(`当前页: ${val}`);
      this.sizeForm.pageNo = val;
      this.LocalGetTableData();
    },
    handleSizeChange(val) {
      // console.debug(`每页 ${val} 条`);
      this.sizeForm.pageSize = val;
      this.LocalGetTableData();
    },
    clickEnter() {
      // console.debug(this.pageInput);
      if (this.pageInput == this.page.currentPage) {
        return;
      }
      if (this.pageInput > this.page.totalPage) {
        this.pageInput = this.page.totalPage;
      }
      this.loading = true;
      this.sizeForm.pageNo = this.pageInput;
      this.LocalGetTableData();
    },
    LocalGetTableData() {
      var _this = this;
      this.loading = true;
      let params = {
        pageNo: this.sizeForm.pageNo,
        pageSize: this.sizeForm.pageSize,
      };
      this.getTableData(params).then((res) => {
        this.loading = false;
        this.showNoData = true;
        _this.tableData = res.data;
        let pages = res.page;
        _this.page = {
          currentPage: pages.currentPage,
          totalPage: pages.totalPage,
        };
      });
    },
  },
  computed: {
    maxTableHeight() {
      return this.tableHeight - 190;
    },
  },
};
</script>
<style lang="scss" scoped>
* {
  color: #1f1f1f;
}
.middle{
  margin-bottom: 20px;
  .middle-introduction{
    margin: 60px 0 50px;
    font-size: 12px;
    color: var(--font_01);
  }
}
.xh-esg-index {
  background: var(var(--comp_08));
}
.top {
  margin-top: 25px;
}
.dataTable {
  margin-top: 14px;

  height: 100%;
  width: 100%;
}
.select {
  margin-top: 14px;

  height: 191px;
  width: 100%;
}
.content {
  width: 1100px;
  margin: 0 auto;
  padding-left: 40px;
}
.icon {
  margin-right: 13px;
}
.xh-esg-index {
  margin: 0;
  padding: 0;
}
.banner {
  height: 220px;
  background: url("../../assets/white_theme/esg-rz-banner.png") no-repeat;
  background-position: center;
  background-size: cover;
}
.introduction {
  margin-top: 28px;
  color: var(--font_01);
}
body {
  margin: 0;
}
.card {
  width: 100%;
  height: 144px;

  margin-top: 67px;
}
.goldCard {
  width: 407px;
  height: 144px;

  float: left;
  margin-left: 116px;
}
.goldCardint {
  margin-left: 63px;
  width: 336px;
  height: 144px;

  float: left;
  margin-top: 31px;
}
.circle {
  float: left;
  z-index: 79;
  width: 18px;
  height: 18px;
  background-color: rgba(122, 213, 244, 1);
  border-radius: 50%;
  margin-right: 11px;
}
.mingpian {
  margin-left: 29px;
  margin-top: 10px;
  font-size: 12px;
  color: var(--font_01);
}
.bbb {
  font-size: 16px;
  color: var(--xhcj-rz-title);
}
.serve {
  margin-top: 72px;
  height: 114px;
  width: 100%;
}
.serveLeft {
  margin-left: 134px;
  width: 321px;

  float: left;
}
.serveInt {
  height: 68px;
  width: 350px;
  margin-left: 29px;
  margin-top: 10px;
  font-size: 12px;
  color: var(--font_01);
}
.serveRight {
  width: 206px;
  height: 114px;
  float: left;

  margin-left: 130px;
}
.liucheng {
  width: 100%;
  // height: 170px;
  margin-top: 79px;
}
.liuchengleft {
  // height: 100px;
  width: 234px;
  margin-left: 178px;

  float: left;
  .liuchengleft-content{
    margin-top: 60px;
    font-size: 12px;
    color: var(--font_01);
  }
}
.liuchengright {
  margin-left: 81px;
  // margin-top: 21px;

  height: 96px;
  width: 381px;
  float: left;
  font-size: 12px;
  color: var(--font_01);
  .liuchengright-content{
    margin-left: 29px;
    margin-top: 10px;
    font-size: 12px;
    color: var(--font_01);
  }
}
.rzcompany {
  height: 186px;
  width: 100%;

  margin-top: 62px;
}
.one {
  height: 81px;
  width: 81px;

  float: left;
  margin-left: 260px;
  margin-top: 24px;
  // cursor: pointer;
  background: url(../../assets/white_theme/esg-rz-add.png);
}
.box {
  height: 81px;
  width: 81px;

  float: left;
  margin-left: 27px;
  margin-top: 24px;
  background: url(../../assets/white_theme/esg-rz-add.png);
  // cursor: pointer;
}
.middlebox {
  height: 120px;
  width: 120px;

  float: left;
  margin-left: 27px;
  cursor: pointer;
  
}
.infoBox1 {
  z-index: 17;
  width: 428px;
  height: 51px;
  display: block;
  overflow-wrap: break-word;
  color: var(--font_01);
  font-size: 12px;
  font-family: PingFangSC-Regular;
  line-height: 17px;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  // margin-left: 300px;
  margin: 0 auto;
}
.ruzhubtn {
  margin: 0 auto;
  display: block;
  background: #4a96fd;
  border-radius: 15px;
  width: 188px;
  height: 49px;

  span {
    color: #fff !important;
  }
}
.top {
  b {
    font-size: 16px;
  }
}
.bottom {
  b {
    font-size: 16px;
  }
}
.serveRightPng {
  background: url(../../assets/white_theme/esg-rz-esg.png);
  height: 100%;
  width: 100%;
  background-size: contain;
}
.Black {
  .serveRightPng {
    background: url(../../assets/black_theme/esg-rz-esg.png);
    height: 100%;
    width: 100%;
    background-size: contain;
  }
  .one {
    background: url(../../assets/black_theme/esg-rz-add.png);
  }
  .box {
    background: url(../../assets/black_theme/esg-rz-add.png);
  }
  .ruzhubtn {
    border: 1px solid;
  }
}
</style>
